import React, { useEffect, useMemo } from 'react';
import gsap from 'gsap';

import useScrollStore from '../../../common/store/useScrollStore';

const useParallax = (ref: React.RefObject<HTMLElement>, vh: number, weight: number) => {
  const ratio = useMemo(() => vh / 100, [vh]);

  useEffect(() => useScrollStore.subscribe(state => {
    const baseline = ratio * window.innerHeight;
    const trigger = baseline - window.innerHeight;

    const range = baseline - trigger;

    if (- state.position > trigger && -state.position <= baseline) {
      const yRatio = 1 - ((baseline + state.position) / range);

      gsap.to(ref.current, {
        duration: 0,
        ease: "power2.out",
        y: - (yRatio * weight),
        overwrite: true
      });
    }
  }), [ref, ratio, weight]);
}

export default useParallax;